export const iconFontAwesomeArrowsArrowsToCircle = (
	<i className="fa-solid fa-arrows-to-circle"></i>
);
